import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export interface IReliableLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  light?: boolean;
  onOpen?(): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export const ReliableLabel = React.forwardRef((props: IReliableLabelProps, ref: React.Ref<HTMLDivElement>) => {
  const background = props.light
    ? /* istanbul ignore next */ ('var(--transparent-blue50a)' as TColors)
    : 'accent-main-primary';

  const color = props.light ? /* istanbul ignore next */ 'accent-main-primary' : 'decorative-theme-white';

  return (
    <div className={styles['label']} {...props} onClick={props.onClick} ref={ref}>
      <Label
        background={background}
        color={color}
        icon={
          <IconProductTrust16
            color={props.light ? /* istanbul ignore next */ 'icon-main-default' : 'icon-inverted-default'}
          />
        }
        onMouseEnter={props.onOpen}
      >
        Надёжный корпус
      </Label>
    </div>
  );
});

ReliableLabel.displayName = 'ReliableLabel';
